module.exports = __webpack_public_path__ + "baab6a1ae0f4639c0fbd3044cce57d77.mp4";